export default function PageLoader({ overlay = false }) {
  return (
    <div
      className={`page-route-loader${overlay ? ' page-route-loader--overlay' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="page-route-loader__spinner" aria-hidden />
      <span className="page-route-loader__text">Loading…</span>
    </div>
  );
}
